export interface EnvironmentConfig {
  isProduction: boolean
  faviconPrefix: string
  borderColor: string
  environment: 'production' | 'staging' | 'development'
}

function getEnvironment(): 'production' | 'staging' | 'development' {
  const nodeEnv = import.meta.env.NODE_ENV
  const vercelEnv = import.meta.env.VERCEL_ENV

  if (nodeEnv === 'production' && vercelEnv === 'production') {
    return 'production'
  }
  if (nodeEnv === 'production' || vercelEnv === 'preview') {
    return 'staging'
  }
  return 'development'
}

function createEnvironmentConfig(): EnvironmentConfig {
  const environment = getEnvironment()
  const isProduction = environment === 'production'

  return {
    isProduction,
    environment,
    faviconPrefix: isProduction ? '' : 'staging-',
    borderColor: isProduction ? '#4E9680' : '#D4AF37', // Green for production, gold/yellow for staging/dev
  }
}

export const envConfig = createEnvironmentConfig()
